import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { NavBarTab } from "./nav-bar-tab";

export const NavBarTabs = () => {
    const { isAuthenticated } = useAuth0();

    return (
        <div className="nav-bar__tabs">
            {/*<NavBarTab path="/profile" label="Profile" />*/}
            {/*<NavBarTab path="/public" label="Public" />*/}
            {isAuthenticated && (
                <>
                    <NavBarTab path="/company" label="Infos entreprise" />
                    <NavBarTab path="/cse" label="CSE" />
                    <NavBarTab path="/utils" label="Utilisateurs" />
                    <NavBarTab path="/representation" label="Representation" />
                </>
            )}
        </div>
    );
};
